import React from 'react';
import PasswordInput from '../UI/PasswordInput';

const ResetPasswordModalContent = ({ register, errors }) => {
  return (
    <>
      <h5 className="mb-4">New Password</h5>
      <PasswordInput 
        name="password" 
        register={register({ 
          required: "You must specify a password", 
          minLength: {
            value: 8,
            message: "Password must have at least 8 characters"
          }
        })}
        placeholder="Password"
      />
      {errors.password && errors.password.type === "required" &&
        <p className="warnMessage">This field is required</p>
      }
      {errors.password && errors.password.type === "minLength" && 
        <p className="warnMessage">The password is too short</p>
      }
    </>
  )
}

export default ResetPasswordModalContent;